import styled from 'styled-components';
import * as React from 'react';

type MountFn = (el: HTMLDivElement, props: any) => void;

interface MountProps {
  containerId: string;
  mount: MountFn;
  mountProps: any;
}

const StyledDiv = styled.div`
  margin-left: 24px;
  position: absolute;
`;

/**
 * Creates a div and mounts content within it by calling the provided mount function.
 *
 * @param containerId {string} The id to be assigned to the container div.
 * @param mount {MountFn} A function that mounts DOM elements within the provided container.
 * @param mountProps {MountProps} Props to be passed to the mount function
 * @constructor Creates a Mount react component.
 */
const Mount: React.FunctionComponent<MountProps> = ({
  containerId,
  mount,
  mountProps,
}) => {
  const ref = React.useRef(null);

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    mount(ref.current, mountProps);
  }, [mountProps]);

  return <StyledDiv id={containerId} ref={ref} />;
};

export default Mount;
